import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function AgentCountReport() {
    const [agentCount, setAgentCount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAgentCount = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get("https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/agentCount");
            setAgentCount(response.data.split(" ")[3]);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
            setError("Не удалось загрузить данные. Пожалуйста, попробуйте позже.");
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по количеству агентов",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({
                            text: `Количество агентов: ${agentCount}`,
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "agent_count_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>📊 Количество агентов</h2>

            {error && (
                <div className="otch-error-message">
                    <span className="otch-error-icon">⚠️</span> {error}
                </div>
            )}

            {agentCount !== null && !error && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Общее количество агентов в системе: <span className="otch-highlight">{agentCount}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={fetchAgentCount}
                    disabled={loading}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        <>
                            📈 Сформировать отчет
                        </>
                    )}
                </button>
                {agentCount !== null && !error && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать Word
                    </button>
                )}
            </div>
        </div>
    );
}

export default AgentCountReport;